import { render, staticRenderFns } from "./SatellitalBandSelector.vue?vue&type=template&id=04475039&scoped=true"
import script from "./SatellitalBandSelector.vue?vue&type=script&lang=ts"
export * from "./SatellitalBandSelector.vue?vue&type=script&lang=ts"
import style0 from "./SatellitalBandSelector.vue?vue&type=style&index=0&id=04475039&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04475039",
  null
  
)

export default component.exports